// extracted by mini-css-extract-plugin
module.exports = {"technicalSpecsWrapper":"v1_technicalSpecsWrapper__eseuJ"};